import { render, staticRenderFns } from "./TemplateAuth.vue?vue&type=template&id=365267fb&scoped=true&"
import script from "./TemplateAuth.vue?vue&type=script&lang=js&"
export * from "./TemplateAuth.vue?vue&type=script&lang=js&"
import style0 from "./TemplateAuth.vue?vue&type=style&index=0&id=365267fb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365267fb",
  null
  
)

export default component.exports